import { StyledTutorialKeys } from "../TutorialKeys.styled"

export const TutorialCombosAdvances = () => {
  return (<StyledTutorialKeys>
    <div className="key-definition">
      <div className="key">
        <span className="key-text">JUMP</span>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>Q</i></div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>E</i></div>
      </div>
      <div className="key-action">SHANGOOLI SPIN PUNCH</div>
    </div>
    <div className="key-definition">
      <div className="key">
        <span className="key-text">JUMP</span>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>E</i></div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>E</i></div>
      </div>
      <div className="key-action">FLYING SHOKUNIN KICK</div>
    </div>
    <div className="key-definition">
      <div className="key">
        <div className="tutorial-key arrow">←</div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>E</i></div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>E</i></div>
      </div>
      <div className="key-action">BROADSIDE DASH LEFT</div>
    </div>
    <div className="key-definition">
      <div className="key">
        <div className="tutorial-key arrow">→</div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>E</i></div>
        <span className="key-combo">→</span>
        <div className="tutorial-key"><i>E</i></div>
      </div>
      <div className="key-action">BROADSIDE DASH RIGHT</div>
    </div>
  </StyledTutorialKeys>)
};
